import { connect } from 'react-redux';
import {
  reduxForm,
  formValueSelector,
  change,
  arrayInsert,
  arrayPush,
  getFormSyncErrors,
} from 'redux-form';
import _ from 'lodash';
import { editGuestGroupV2 } from '../../../../actions/GuestActions';
import {
  hideModal,
  showSecondaryModal,
  hideSecondaryModal,
} from '../../../../actions/ModalActions';

import EditGuestGroupForm from './EditGuestGroupForm';

const selector = formValueSelector('editGuestGroupForm');

const mapStateToProps = (state, ownProps) => {
  let initialValues = {};
  const guestGroupsById = state.guestList.guests.byId;
  const guestGroup = guestGroupsById[ownProps.guestGroupId] || {};

  const initialEventInvitations = state.events.events.orderedIds.reduce(
    (result, eventId) => {
      result.orderedIds.push(eventId);
      const event = state.events.events.byId[eventId];
    result[eventId] = { // eslint-disable-line
        name: event.name,
        event_id: eventId,
        checked: false,
        meal_option_id: null,
        rsvp_type: 'NO_RESPONSE',
        rsvp_at: null,
      };
      return result;
    },
    { orderedIds: [] }
  );

  if (guestGroup.guests && guestGroup.guests.length > 0) {
    const guests = guestGroup.guests.map(guest => ({
      id: guest.id,
      prefix: guest.prefix,
      first_name: guest.first_name,
      middle_name: guest.middle_name,
      family_name: guest.family_name,
      suffix: guest.suffix,
      rsvp: guest.rsvp,
      meal_option_id: guest.meal_option && guest.meal_option.id,
      relationship_type: guest.relationship_type,
      name_unknown: !guest.first_name && !guest.family_name,
      source: guest.source,
      event_invitations: guest.event_invitations.reduce(
        (result, eventInvitation) => {
          const initialEventInvitation = initialEventInvitations[eventInvitation.event_id];
        result[eventInvitation.event_id] = Object.assign({}, initialEventInvitation, eventInvitation, { checked: true }); // eslint-disable-line
          return result;
        },
        { ...initialEventInvitations }
      ),
    }));

    const checkedEvents = guests[0].event_invitations.orderedIds.reduce(
      (result, eventId) => {
        result.eventIds.push(eventId);
      result[eventId] = guests[0].event_invitations[eventId].checked; // eslint-disable-line
        return result;
      },
      { eventIds: [] }
    );

    const eventInvitations = state.events.events.orderedIds.reduce(
      (result, eventId) => {
        result.orderedIds.push(eventId);
      result[eventId] = { // eslint-disable-line
          event_id: eventId,
          checked: checkedEvents[eventId],
          name: state.events.events.byId[eventId].name,
        };
        return result;
      },
      { orderedIds: [] }
    );

    const rsvpQuestions = _.flatMap(state.events.events.byId, event => event.rsvp_questions);
    const initialRsvpQuestionAnswers = rsvpQuestions.reduce(
      (result, question) => {
        result.orderedIds.push(question.id);
        const answer =
          guestGroup.rsvp_question_answers.filter(a => a.rsvp_question_id === question.id) || [];
      result[question.id] = { // eslint-disable-line
          rsvp_question_id: question.id,
          answer: answer[0] ? answer[0].answer : '',
        };
        return result;
      },
      { orderedIds: [] }
    );

    initialValues = {
      id: guestGroup.id,
      wedding_account_id: guestGroup.wedding_account_id,
      address_1: guestGroup.address_1,
      address_2: guestGroup.address_2,
      city: guestGroup.city,
      state_province: guestGroup.state_province,
      postal_code: guestGroup.postal_code,
      country_code: guestGroup.country_code || 'US',
      email_address: guestGroup.email_address,
      home_phone: guestGroup.home_phone,
      mobile_phone: guestGroup.mobile_phone,
      affiliation: guestGroup.affiliation,
      tier: guestGroup.tier,
      invitation_sent: guestGroup.invitation_sent.toString(),
      invited: guestGroup.invited.toString(),
      save_the_date_sent: guestGroup.save_the_date_sent.toString(),
      envelope_recipient: guestGroup.envelope_recipient,
      envelope_recipient_override: guestGroup.envelope_recipient_override,
      rsvp_question_answers: initialRsvpQuestionAnswers,
      guests,
      event_invitations: eventInvitations.orderedIds.map(id => eventInvitations[id]),
    };
  }

  const rsvpQuestions = _.chain(state.events.events.byId)
    .flatMap(event => event.rsvp_questions)
    .reduce(
      (result, question) => {
        result.orderedIds.push(question.id);
      result[question.id] = question; // eslint-disable-line
        return result;
      },
      { orderedIds: [] }
    )
    .value();

  return {
    hasErrors: !_.isEmpty(getFormSyncErrors('editGuestGroupForm')(state)),
    initialValues,
    invitedFormValue: selector(state, 'invited'),
    guestFormValues: selector(state, 'guests'),
    eventFormValues: selector(state, 'event_invitations') || [],
    initialPanel: ownProps.activeTab,
    wedding: state.wedding.wedding,
    rsvpQuestions,
    rsvpQuestionOrderedIds: state.website.entities.orderedIds,
    mealOptions: state.website.entities.mealOptions,
    events: state.events.events,
    activeEventTab: state.guestList.guests.activeEventTab,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: createGuestGroupRequest => {
    dispatch(editGuestGroupV2(createGuestGroupRequest))
      .then(() => {
        if (ownProps.callback) ownProps.callback();
      })
      .then(() => dispatch(hideModal()));
  },
  handleEventInvitation: (guests, eventInvitation, eventIndex) => {
    const isChecked = eventInvitation.checked === true;
    const eventInvitations = _.flatMap(
      guests,
      guest => guest.event_invitations[eventInvitation.event_id]
    );
    const hasResponses = eventInvitations.some(
      eventInvite =>
        eventInvite.event_id === eventInvitation.event_id && eventInvite.rsvp_at !== null
    );
    if (isChecked && hasResponses) {
      const onConfirmAction = () => {
        dispatch(change('editGuestGroupForm', `event_invitations[${eventIndex}].checked`, false));
        guests.forEach((guest, index) => {
          if (guest.event_invitations) {
            dispatch(
              change(
                'editGuestGroupForm',
                `guests[${index}].event_invitations[${eventInvitation.event_id}].checked`,
                false
              )
            );
          }
        });
        return dispatch(hideSecondaryModal());
      };
      dispatch(
        showSecondaryModal('BULK_UNINVITE_CONFIRMATION', { onConfirmAction }, { size: 'md' })
      );
    } else {
      dispatch(
        change('editGuestGroupForm', `event_invitations[${eventIndex}].checked`, !isChecked)
      );
      guests.forEach((guest, index) => {
        if (guest.event_invitations) {
          dispatch(
            change(
              'editGuestGroupForm',
              `guests[${index}].event_invitations[${eventInvitation.event_id}].checked`,
              !isChecked
            )
          );
        }
      });
    }
  },
  onUninvite: guests => {
    const eventInvitations = _.flatMap(guests, (guest) => { // eslint-disable-line
      return guest.event_invitations.orderedIds.map(eventId => guest.event_invitations[eventId]);
    });
    const hasResponses = eventInvitations.some(eventInvitation => eventInvitation.rsvp_at !== null);
    if (hasResponses) {
      const onConfirmAction = () => {
        dispatch(change('editGuestGroupForm', 'invited', 'false'));
        dispatch(hideSecondaryModal());
      };
      dispatch(
        showSecondaryModal('UNINVITE_GUEST_CONFIRMATION', { onConfirmAction }, { size: 'md' })
      );
    } else {
      dispatch(change('editGuestGroupForm', 'invited', 'false'));
    }
  },
  onAddGuest: (type, eventFormValues) => {
    const eventInvitations = eventFormValues.reduce(
      (result, eventInvitation) => {
        result.orderedIds.push(eventInvitation.event_id);
      result[eventInvitation.event_id] = { // eslint-disable-line
          event_id: eventInvitation.event_id,
          name: eventInvitation.name,
          checked: eventInvitation.checked,
          meal_option_id: null,
          rsvp_at: null,
          rsvp_type: 'NO_RESPONSE',
        };
        return result;
      },
      { orderedIds: [] }
    );
    if (type === 'PARTNER') {
      dispatch(
        arrayInsert('editGuestGroupForm', 'guests', 1, {
          relationship_type: 'PARTNER',
          source: 'MANUAL',
          event_invitations: eventInvitations,
        })
      );
    } else if (type === 'CHILD') {
      dispatch(
        arrayPush('editGuestGroupForm', 'guests', {
          relationship_type: 'CHILD',
          source: 'MANUAL',
          event_invitations: eventInvitations,
        })
      );
    }
  },
});

const EditGuestGroupFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'editGuestGroupForm',
    destroyOnUnmount: true, // <------ preserve form data
    forceUnregisterOnUnmount: false,
  })(EditGuestGroupForm)
);

export default EditGuestGroupFormContainer;



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/EditGuestGroupFormContainer.jsx